import { Order, OrderCalculation, OrderLoadingExt, OrderUnloading } from "../../../../api/types/order"
import { validateCalculation } from "./calculation"
import { validateGoods } from "./goods"
import { validateLoading } from "./loading"
import { validateUnloading } from "./unloading"

export const getLastSuccessStepIndex = (order?: Order): number => {
  if (!order) {
    return 0
  }

  if (order.state >= 10 && order.state <= 100) {
    return 5
  }

  const [isLoadingValid] = validateLoading({
    loading: Object.assign({}, order.loading) as OrderLoadingExt
  })

  const [isUnloadingValid] = validateUnloading({
    unloading: order.unloading || {} as OrderUnloading
  })

  const [isGoodsValid] = validateGoods({
    goods: order.goods || []
  }, order)

  const [isCalculationValid] = validateCalculation({
    calculation: order.calculation || {} as OrderCalculation
  }, false)

  if (
    order.loading !== null && isLoadingValid &&
    order.unloading !== null && isUnloadingValid &&
    order.goods !== null && isGoodsValid &&
    order.calculation !== null && isCalculationValid
  ) {
    return 4
  }

  if (
    order.loading !== null && isLoadingValid &&
    order.unloading !== null && isUnloadingValid &&
    order.goods !== null && isGoodsValid
  ) {
    return 3
  }

  if (
    order.loading !== null && isLoadingValid &&
    order.unloading !== null && isUnloadingValid
  ) {
    return 2
  }

  if (
    order.loading !== null && isLoadingValid
  ) {
    return 1
  }

  return 0
}
